import React from "react";

const PortfolioTwo = () => (
  <div>

	<h1>Backend</h1>

  <p>This website is hosted on <a 
  href={"https://www.heroku.com/"} target={"_blank"}>Heroku</a>, a 
    "Platform As A Service" business.</p>

    <p>Thanks to a package called <a 
    href={"https://www.npmjs.com/package/express-subdomain/"} 
      target={"_blank"}>express-subdomain</a>, a single
        node-express application running on Heroku serves the pages
        and provides backend support for all webpages that
        include "Charles-W-Roberts.com" in their URL.</p>
        <p>  As of  May 2018, this one single application is serving webpages 
          and servicing backend requests for www.Charles-W-Roberts.com, 
        iNeed2.Charles-W-Roberts.com, iNeed2.Charles-W-Roberts.com/Bugs.html, 
        WhurzIt.Charles-W-Roberts.com, WhurzIt.Charles-W-Roberts.com/Bugs.html, 
        PC-Tran.Charles-W-Roberts.com and PC-Tran.Charles-W-Roberts.com/docs.</p>

  </div>
);

export default PortfolioTwo;


// WEBPACK FOOTER //
// ./src/components/Portfolio/PortfolioTwo.js